import {
  faBuildingUser,
  faBarsProgress,
  faDashboard,
  faDiceD20,
  faCartShopping,
  faArrowDownWideShort,
  faAnglesRight,
  faDiamondTurnRight,
  faScrewdriverWrench,
  faRightToBracket,
  faCubesStacked,
  faGroupArrowsRotate,
  faBrazilianRealSign,
  faFileSignature,
  faFileInvoiceDollar,
  faGem,
  faFileEdit,
  faAddressBook,
  faMoneyCheckDollar,
  faRankingStar,
  faDiamond,
  faUserCheck,
  faBoxesPacking,
  faRouble,
  faCheckToSlot,
  faBarcode,
  faDollar,
  faRssSquare,
  faListNumeric,
  faHomeUser,
  faUserAlt,
  faUserClock,
  faToolbox,
  faGear,
  faBuilding,
  faPeopleArrows
} from "@fortawesome/free-solid-svg-icons"
import CryptoJS from 'crypto-js';

export const GetLoginCredentialDb = (user, yearId) => {
  return { YearId: yearId, ClientCode: user.clientCode, LoginName: user.username, UserKey: user.userKey }
}

export const ENUM_USERSETING_PARAMS = {
  StartUp: "STARTUP",
}

export const ENUM_BILL_PAYMENT_TYPE = {
  FULL: "FULL",
  PART: "PART",
}
const outTypeEnum = {
  R: "R",
  G: "G",
  C: "C"
}

export const ENUM_USER_TYPE = {
  USER: "USR",
  DISTRIBUTOR: "DST"

}

export const ENUM_DISPLAY_USERTYPE = {
  USER: "USR - USER",
  DISTRIBUTOR: "DST - DISTRIBUTOR"

}
export const ENUM_BILL_TYPE_LIST = [
  { value: "--Select-", key: "" },
  { value: "FULL", key: "FULL" },
  { value: "PART PAYMENT", key: "PART" }
]
export const ENUM_MOD_NAME = {
  //Memo setting
  GeneralSettings: "General_Settings",
  WebApp_Settings: "WebApp_Settings"

}
export const ENUM_MOD_PARAMETER = {

  GeneralSetting: {
    MixStockByLCode: "Mix_Stock_By_L_Code",
    MixStockByPurity: "Mix_Stock_By_Purity",
    MixStockByColor: "Mix_Stock_By_Color",
    MixStockByItem: "Mix_Stock_By_Item",
    MixStockByShape: "Mix_Stock_By_Shape",
    MixStockByLwRatio: "Mix_Stock_By_LwRatio",
    MixStockBySize: "Mix_Stock_By_Size",
    CurrencyType: "Currency_Type",
    ClientSettingType: "Client_Setting_Type",
    RoughStockByLCode: "Rough_Stock_By_Lcode",
    RoughStockByItem: "Rough_Stock_By_Item",
    RoughStockBySize: "Rough_Stock_By_Size",
    Barcode: "Barcode",
    BarcodeSplitter: "Barcode_Splitter",

  },
  WebApp_Settings:
  {
    ItemGroup: "ItemGroup"
  }

}

export const ENUM_CURRENCY_SETTING_VAL = {
  RS: "RS",
  Dollar: "$",
  DUAL: "DUAL",
}

export const ENUM_CLIENT_SETTING_VAL = {
  SINGLE: "SNG",
  MIX: "MIX",
  DUAL: "DUAL",
}



export const ENUM_BILL_TYPE = {
  Sale: "Sale",
  Purchase: "Purchase",

}
export const ENUM_ADVSEARCH_PARAM = {
  VouNo: "VouNo",
  Shape: "Shape",
  Color: "Color",
  Purity: "Purity",
  Size: "Size",
  LwRatio: "LwRatio",
  Party: "Party",
  Broker: "Broker",
  Item: "Item",
  VouFromDate: "VouFromDate",
  VouToDate: "VouToDate",
  DueFromDate: "DueFromDate",
  DueToDate: "DueToDate",
  Status: "Status"

}
export const PAGE_API_FILTER = {
  CompCode: 0, BillType: '', TradeOF: ""
}
export const ENUM_STATUS = {
  Final: "Final",
  Pending: "Pending",
  Return: "Return",
  PartialReturn: "PartialReturn",
  PartialFinal: "PartialFinal",
  Paid: "Paid",
  PartPaid: "PartPaid"
}
export const ENUM_ENTRY_TYPE = {
  SinglePacket: "Single",
  Mix: "Mix",

}
export const ENUM_TRANSACTION_TYPE = {
  RECEIVE: "Receive",
  PAYMENT: "Payment"

}
export const ENUM_TRADEOF_CODE = {
  Rough: "R",
  Polish: "P",
  Rejection: "J"

}

export const encryptText = (text) => {
  const secretKey = ''; // Use a secret key for encryption
  const ciphertext = CryptoJS.AES.encrypt(text, secretKey).toString();
  return ciphertext;
};

// Decrypt the text
export const decryptText = (ciphertext) => {
  const secretKey = 'mySecretKey'; // Use the same key for decryption
  const bytes = CryptoJS.AES.decrypt(CryptoJS.enc.Hex.parse(ciphertext), secretKey);
  const originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
};

export const ENUM_ADM_KEY = "AdmWebApp"

export const funValidateNoInput = (value) => {

  if (/^\d*\.?\d*$/.test(value))
    return true
  else
    return false

}

export const getModVisiblity = (Parameter, data) => {

  if (data && data.length > 0) {
    const filData = data.filter((ele) => ele.Parameter == Parameter)

    if (filData && filData?.length > 0)
      return filData[0].Visible.toLowerCase() == 'true' ? true : false;
    else return false

  }
  else
    return false
}

export const getModMandatory = (Parameter, data) => {
  if (data && data.length > 0) {
    const filData = data.filter((ele) => ele.Parameter == Parameter)
    if (filData && filData?.length > 0)
      return filData[0].Mandatory.toLowerCase() == 'true' ? true : false;
    else
      return false
  }
  else
    return false
}
export const URIEncrypt = {
  Sale: "5envOAgVIY4C3AppqTIOQ==",
  Purchase: "AajKIeaOgKPSeDe3n9h1Q==",
  Polish: "ABF40G4rF0BTYceit5FgLA==",
  Rough: "RJZMdz5xYlPAEyPCqdGqeg==",
  Rejection: "aOKtLyyf7pa2I7ql8HGdtA==",
  SinglePacket: "J1uV3jz9q4Wz4L4KSZzirw==",
  Mix: "TyQE506fA9dJbvTP7PUuvw==",
  Receive: "lWYAoq7z3vmSG76yXvlWuw==",
  Payment: "VlTLnoBtRtoh2hmXsiFkFQ=="
}

export const getModValue = (Parameter, data) => {

  if (data && data.length > 0) {
    const filData = data.filter((ele) => ele.Parameter == Parameter)
    if (filData && filData?.length > 0)
      return filData[0].Value
    else
      return ""
  }
  else
    return ""
}

const linksUrl = {
  companies: "/",
  test: "/test",
  login: "/login",
  dashboard: "/dashboard",
  user: {
    userMaster: "/user-master",
    createUserEntry: "/user/create-entry"
  },
  resetPassword: "/user/resetpassword",
  master: {
    item: {
      itemMaster: "/master/item-master",
      createItemMaster: "/master/item/create-entry"
    },
    account: {
      accountMaster: "/account-master",
      createAccountMaster: "/acc/create-entry"
    },

  },
  modSetting: {
    modSettingMaster: "/mod-settings",
    createmodSettingMaster: "/create-mod-settings"
  },


  salesOrder: {
    createEntry: "/salesorder/Place-Order",
    orderMaster: "/salesorder/order-list"
  },
  purchaseOrder: {
    createEntry: "/purchase/Place-Order",
    orderMaster: "/purchase/order-list"
  },
  salesData: {
    getList: "/reports/trading-data",
    rptInvoice: "/invoice/report",
    detail: "/sales/detail",
  },

  userCompMaping: {
    get: "/user-company-maping"
  },

  userPartyMaping: {
    get: "/user-party-maping"

  },



}

export const ENUM_TRADE_TYPE = [{ t_type: "RD" }, { t_type: "URD" }, { t_type: "OGS" }]
const stateEnum = {
  company: "company",
  auth: "auth",
  item: "item",
  account: "account",
  order: "order",


}

export const funGetSalePurURL = (billTYpe, tradeOf, entryType) => {
  return linksUrl.salePurchaseEntry + billTYpe + "/" + tradeOf + "/" + entryType + linksUrl.memoEntry.memoEntryMaster;
}
export const FixScreenHeight = 'calc(100vh - 7rem)'
export const FixMobileHeight = 'calc(100vh - 11.5rem)'
const apiRoute = {
  company: "/company",
  companyAcYear: "/company/ac-year",
  setAcYearId: "/company/set-yearid",
  resetPassword: "/user/reset-password",
  item: {
    fetch: "/item/fetch-item",
    deleteitem: "/item/item-delete",
    masterData: "/item/master-data",
    fetchGstType: "/item/gst-type",
    addUpdate: "/item/add-update",
    checkItemCode: "/item/check-item-code"
  },
  user: {
    checkLoginId: "/user/check-loginid",
    addUpdate: "/user/add-update",
    deleteEntry: "/user/delete-entry",
    fetch: "/user/entry-data",
    entryDetail: "/user/entry-detail",
    getEntryMasterData: "/user/master-data"
  },
  account: {
    fetch: "/account/fetch-account",
    deleteAccount: "/account/account-delete",
    masterTypeProcess: "/account/master-type-process",
    masterPartyTradeState: "/account/master-party-trade-state",
    checkacid: "/account/check-acid",
    add: "/account/add",
    fetchAcByType: "/account/account-by-type",
    addBroker: '/account/broker/add',
    fetchBroker: '/account/broker/fetch',
    addTransport: '/account/transport/add',
    fetchTransport: '/account/transport/fetch',
    addDelivery: '/account/delivery/add',
    fetchDelivery: '/account/delivery/fetch',
    verifyGstDetail: '/account/gst-verify'
  },
  modSetting: {
    masterModList: "/mod-setting/mod-list",
    fetchModData: "/mod-setting/mod-data",
    add: "/mod-setting/add",
    update: "/mod-setting/update",
    getAppType: "/mod-setting/app-type",
    getModSetting: "/mod-setting/get-setting",
    getMultiModSetting: "/mod-setting/get-multi-setting"

  },
  userCompMaping: {
    masterData: "/usercomp-maping/master-data",
    addUpdate: "/usercomp-maping/add-update",
    getUserMaping: "/usercomp-maping/user-maping",
    getUserBrokerMaping: "/usercomp-maping/broker-maping",
    getMappedCompany: "/usercomp-maping/get-mapcomp"
  },

  userPartyMaping: {
    masterData: "/userparty-map/master-data",
    addUpdate: "/userparty-map/add-update",
    getPartyMaping: "/userparty-map/user-maping",
    getUserpartyMaping: "/userparty-map/get-mapparty"
  },

  saleOrder: {
    fetch: "/sale-order/fetch",
    masterData: "/sale-order/master-data",
    addUpdate: "/sale-order/add-update",
    getItemRate: "/sale-order/item-rate",
    getMasterItem: "/sale-order/items",
    deleteEntry: "/sale-order/delete-entry",
    entryDetail: "/sale-order/entry-detail",
    getBrokerParty: "/sale-order/broker-party",
    getOrder: "/sale-order/ord-data",

  },
  salesData: {
    fetch: "/sales",
    fetchInvoiceDetail: "/sales/detail",
    fetchAccount: "/sales/account-master",
    getData: '/sales/getdata',
    getParties: '/sales/getparties'
  },

}

const sideNavLinks = [
  {
    name: "Company",
    key: "Companies",
    icon: faBuilding,
    color: "text-lime-700",
    url: linksUrl.companies,
  },
  {
    name: "Home",
    key: "Dashboard",
    color: "text-red-700",
    icon: faHomeUser,
    url: linksUrl.dashboard,
  },

  {
    name: "Sale Order",
    key: "SaleOrderEntry",
    color: "text-pink-700",
    icon: faBoxesPacking,
    url: linksUrl.salesOrder.orderMaster,
  },

  // {
  //   name: "Purchase Order",
  //   key: "PurchaseOrderEntry",
  //   color: "text-pink-700",
  //   icon: faBoxesPacking,
  //   url: linksUrl.purchaseOrder.orderMaster,
  // },
  {
    name: "Account",
    key: "AccountEntry",
    icon: faAddressBook,
    color: "text-cyan-700",
    url: linksUrl.master.account.accountMaster,
  },
  {
    name: "User",
    key: "OrdAppUserEntry",
    icon: faUserAlt,
    color: "text-yellow-700",
    url: linksUrl.user.userMaster,
  },
  {
    name: "User Party mapping",
    key: "UserPartyMapping",
    icon: faPeopleArrows,
    color: "text-violet-700",
    url: linksUrl.userPartyMaping.get,
  },
  // {
  //   name: "Master",
  //   key: "Master",
  //   icon: faBarsProgress,
  //   color: "text-purple-700",
  //   sub: [
  //     {
  //       name: "Account",
  //       key: "AccountMaster",
  //       icon: faAnglesRight,
  //       url: linksUrl.master.account.accountMaster,
  //     },
  //     {
  //       name: "Item",
  //       key: "ItemMaster",
  //       icon: faAnglesRight,
  //       url: linksUrl.master.item.itemMaster,
  //     },

  //   ]
  // },

  {
    name: "User Setting",
    key: "UserSetting",
    icon: faGear,
    color: "text-red-700",
    sub: [

      {
        name: "Company Mapping",
        key: "UserCompanyMaping",
        icon: faAnglesRight,
        url: linksUrl.userCompMaping.get,
      },

    ]






  },
  {
    name: "Software Setting",
    key: "SoftwareSettings",
    icon: faScrewdriverWrench,
    color: "text-blue-700",
    sub: [
      {
        name: "Mod Settings",
        key: "ModSettings",
        icon: faAnglesRight,
        url: linksUrl.modSetting.modSettingMaster,
      }]
  }
]

const ENUM_DASHBOARD_COLOR = {
  Party: "party",
  jobWork: "jobwork",
  Month: "month",
  Product: "product",
  Comb_Receivable: "Receivable",
  Comb_Payable: "Payable",
  Comb_Difference: "Difference",
  Comb_MonthYear: "Monthyear"
}
export const ENUM_USERSETING_SETVALUE = {
  TextileCostFinance: "TEXTILE COST & FINANCIAL",
}

const ENUM_INPUT_TYPE = {
  text: "text",
  number: "number",
  select: "select",
  email: "email",
  date: "date",
  url: "url",
  multiline: "multiline",
  autocomplete: "autocomplete"
}

export const ENUM_ACTYPE = {
  Transapoter: "Transapoter",
  Broker: "Broker",
  Delivery: "Delivery Party"
}


export { linksUrl, outTypeEnum, stateEnum, apiRoute, sideNavLinks, ENUM_INPUT_TYPE, ENUM_DASHBOARD_COLOR }
